import axios from 'axios'

export default {
    getRoasts() {
        return axios.get('/roast/v1')
            .then(response => {
                return response.data
            })
    }
}